/**
 * Copied from https://github.com/miguelmota/Navigator.sendBeacon/blob/master/sendbeacon.js
 *
 * Needed to copy this into this codebase to disable the withCredentials setting
 *
 * @param val
 * @returns {boolean}
 */

const isString = val => typeof val === 'string';
const isBlob = val => val instanceof Blob;

polyfill.call(typeof window === 'object' ? window : this);

function polyfill() {
  if (isSupported.call(this)) return;

  if (!('navigator' in this)) this.navigator = {};
  this.navigator.sendBeacon = sendBeacon.bind(this);
}

function sendBeacon(url, data) {
  const event = this.event && this.event.type;
  const sync = event === 'unload' || event === 'beforeunload';

  const xhr =
    'XMLHttpRequest' in this
      ? new XMLHttpRequest()
      : // eslint-disable-next-line no-undef
        new ActiveXObject('Microsoft.XMLHTTP');
  xhr.open('POST', url, !sync);
  /**
   * Commenting this out since it is causing this error:
   *
   * Access to XMLHttpRequest at 'https://739306fb-cb1c-47f4-be66-417e79f90779.mock.pstmn.io/V1/analytics' from origin
   * 'http://localhost:3000' has been blocked by CORS policy: The value of the 'Access-Control-Allow-Origin' header in
   * the response must not be the wildcard '*' when the request's credentials mode is 'include'. The credentials mode of
   * requests initiated by the XMLHttpRequest is controlled by the withCredentials attribute.
   **/
  // xhr.withCredentials = true;
  xhr.setRequestHeader('Accept', '*/*');

  if (isString(data)) {
    xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
    xhr.responseType = 'text/plain';
  } else if (isBlob(data) && data.type) {
    xhr.setRequestHeader('Content-Type', data.type);
  }

  try {
    xhr.send(data);
  } catch (error) {
    return false;
  }

  return true;
}

function isSupported() {
  return 'navigator' in this && 'sendBeacon' in this.navigator;
}
